export const getFacilityName = (teamId, facilities) => {
  const facility = facilities.find(
    (facility) => facility.kpro_team_id === teamId
  )
  return facility ? facility.facility_name : 'N/A'
}

export const formatDicomLogs = (logs, facilities) => {
  return logs?.map((log) => ({
    ...log,
    kproTeamId:
      getFacilityName(log.kproTeamId, facilities || []) ||
      'N/A',
    facility_id: log.facility_id || 'N/A',
    order_number: log.order_number || 'N/A',
    message_id: log.message_id || 'N/A',
    createdAt: log.createdAt,
  }))
}
